import { toast } from 'react-toastify';
import { ReactComponent as SuccessIcon } from '../../assets/icone/toast/success.svg';
import { ReactComponent as ErrorIcon } from '../../assets/icone/toast/error.svg';
import { ReactComponent as InfoIcon } from '../../assets/icone/toast/info.svg';
import { ReactComponent as WarningIcon } from '../../assets/icone/toast/warning.svg';

// Oggetto per memorizzare i toast attivi
const activeToasts = {};

export const showToast = {
  success: (message) => {
    if (!activeToasts[message]) {
      const toastId = toast.success(message, {
        icon: <SuccessIcon />,
        onClose: () => delete activeToasts[message],
      });
      activeToasts[message] = toastId;
    }
  },
  
  error: (message) => {
    if (!activeToasts[message]) {
      const toastId = toast.error(message, {
        icon: <ErrorIcon />,
        onClose: () => delete activeToasts[message],
      });
      activeToasts[message] = toastId;
    }
  },
  
  info: (message) => {
    if (!activeToasts[message]) {
      const toastId = toast.info(message, {
        icon: <InfoIcon />,
        onClose: () => delete activeToasts[message],
      });
      activeToasts[message] = toastId;
    }
  },
  
  warn: (message) => {
    if (!activeToasts[message]) {
      const toastId = toast.warn(message, {
        icon: <WarningIcon />,
        onClose: () => delete activeToasts[message],
      });
      activeToasts[message] = toastId;
    }
  },
};
